import React from 'react';

import { PictureProfile } from '../../../../ResizedImage/PictureProfile.csharp';
import { UserContextProvider } from '../../Contexts/UserContext';
import { PhilExpectedDeliveryDateModalWrapper } from './PhilExpectedDeliveryDateModalWrapper';

export interface PhilExpectedDeliveryDateViewWrapperProps {
    logCustomEventUrl: string;
    getExpectedDeliveryDateUrl: string;
    logoPictureProfile: PictureProfile;
    deliveryInfoPage: string;
    cooledDeliveryInfoPageUrl: string;
}

export const PhilExpectedDeliveryDateViewWrapper = (props: PhilExpectedDeliveryDateViewWrapperProps) => {
    return (
        <UserContextProvider>
            <PhilExpectedDeliveryDateModalWrapper {...props} />
        </UserContextProvider>
    );
};
